export default "__VITE_ASSET__4B4YE5Xy__"